import React from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isSuperAdmin, isUserHasPermission } from "../../Utils/Permissions";
import SideMenu from "../SideMenu/SideMenu";
import NoPermissions from "../../Pages/NoPermissions/NoPermissions";

const ProtectedRoute = ({
  component: Component,
  permission,
  requiredRoles,
}) => {

  const { isAuthenticated, userToken } = useSelector((state) => state.auth);
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }


  const permissionArr = permission.length > 0
    ? permission.map((elt) => isUserHasPermission(elt))
    : [true];

  if (permissionArr.some((elt) => elt === true) || isSuperAdmin()) {
    return (
      <div className="">
        <SideMenu component={Component} />
      </div>
    );
  } else {
    return (
      <>
        <SideMenu component={NoPermissions} />
      </>
    );
  }
};

export default ProtectedRoute;
